import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LogInComponent } from "./components/log-in/log-in.component";
import { PlanComponent } from "./components/plan/plan.component";
import { BillingStepComponent } from "./components/billing-step/billing-step.component";
import { ReviewPayComponent } from "./components/review-pay/review-pay.component";
import { AuthGuardGuard } from "./auth/auth-guard.guard";
import { ForZeroFourComponent } from "./components/for-zero-four/for-zero-four.component";
import { PaymentComponent } from "./components/payment/payment.component";
import { SmsBuyComponent } from "./components/sms-buy/sms-buy.component";
import { BiometricBuyComponent } from "./components/biometric-buy/biometric-buy.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "plan",
  },
  { path: "login", component: LogInComponent },
  { path: "plan", component: PlanComponent, canActivate: [AuthGuardGuard] },
  {
    path: "billing",
    component: BillingStepComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: "review-pay",
    component: ReviewPayComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: "payment",
    component: PaymentComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: "sms-buy",
    component: SmsBuyComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: "biometric-buy",
    component: BiometricBuyComponent,
    canActivate: [AuthGuardGuard],
  },
  { path: "**", component: ForZeroFourComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
